// decision-ledger-snake-case-json.ts — review 03b M3: JSON của
// `avatar autopilot status --decisions --json` theo snake_case như
// `status --json` và journal. Kiểu nội bộ giữ camelCase; map ở đây, gọi từ tầng
// lệnh (C/autopilot-status-command.ts). Tên key là hợp đồng cho extension /
// phase 07 — đổi sau beta là breaking (test pin ở
// decision-ledger-snake-case-json.test.ts). Field vắng ⇒ không có key.
import type { DecisionLedger } from "./decision-ledger-types.js";

function defined(record: Record<string, unknown>): Record<string, unknown> {
  return Object.fromEntries(Object.entries(record).filter(([, v]) => v !== undefined));
}

export function decisionLedgerToSnakeCaseJson(ledger: DecisionLedger): Record<string, unknown> {
  return defined({
    journal_status: ledger.journalStatus,
    entries: ledger.entries.map((e) =>
      defined({
        code: e.code,
        origin: e.origin,
        question_id: e.questionId,
        ticket_id: e.ticketId,
        question: e.question,
        option_id: e.optionId,
        option_label: e.optionLabel,
        source: e.source,
        decided_at: e.decidedAt,
      }),
    ),
    worker_recorded: ledger.workerRecorded.map((w) =>
      defined({ ticket_id: w.ticketId, attempt_no: w.attemptNo, text: w.text }),
    ),
    pending: ledger.pending.map((q) =>
      defined({
        question_id: q.questionId,
        ticket_id: q.ticketId,
        question: q.question,
        options: q.options.map((o) => defined({ id: o.id, label: o.label })),
        recommended_option_id: q.recommendedOptionId,
      }),
    ),
  });
}
